import { render } from "./public-facility-card.vue?vue&type=template&id=128ce642&scoped=true"
import script from "./public-facility-card.vue?vue&type=script&lang=js"
export * from "./public-facility-card.vue?vue&type=script&lang=js"

import "./public-facility-card.vue?vue&type=style&index=0&id=128ce642&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128ce642"]])

export default __exports__